import axios, { getData } from 'lib/axios'

export const retrieveEmployeeData = async (items) => {
  const response = await axios.get(`admin/payroll/${items}`)
  const { data, excluded_employees, ...rest } = response.data.data
  return {
    ...rest,
    data: data.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)),
    excluded_employees: (excluded_employees || []).sort((a, b) =>
      a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
    ),
  }
}

export const postPayrollPersonalDetails = async (id, data) => {
  return axios.post(`admin/payroll/${id}/edit-details`, data)
}

export const removeAdjustedEmployee = async (employee_id, time_id) => {
  return axios.get(`admin/payroll/${time_id}/employee/${employee_id}/delete`).then(getData)
}

export const downloadMtdFile = async ({ time_id, employee_id }) => {
  const response = await axios.get(`admin/payroll/${time_id}/employee/${employee_id}/lhdn`, {
    responseType: 'blob',
  })
  return response
}

export const recalculateSelectedEmployee = async ({ time_id, employee_id, data }) => {
  const response = await axios.post(
    `admin/payroll/${time_id}/employee/${employee_id}/calculate`,
    data
  )
  return response
}

export const adjustMtdCalculation = async ({ time_id, employee_id, data }) => {
  const response = await axios.post(
    `admin/payroll/${time_id}/employee/${employee_id}/mtd/edit`,
    data
  )
  return response
}

export const resetMtdCalculation = async (time_id, employee_id) => {
  return axios.get(`admin/payroll/${time_id}/employee/${employee_id}/mtd/reset`).then(getData)
}
